import Vue from 'vue'
import Vuex from 'vuex'
import { TOURIST_LOGIN, USER_INFO } from '@/apis/user'
import { get, post } from '@/utils/http'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    safeArea: JSON.parse(localStorage.getItem('cdb_safe_area')) || { top: 0, bottom: 0 },
    user: JSON.parse(localStorage.getItem('cdb_user')),
    userPwd: JSON.parse(localStorage.getItem('cdb_user_pwd')),
    token: localStorage.getItem('cdb_token'),
    appleIdToken: '',
    loading: false,
    isLangView: false,
    qrcode: localStorage.getItem('cdb_qrcode'),
    zhcode: sessionStorage.getItem('cdb_zhcode'),
    lang: localStorage.getItem('cdb_lang') || process.env.VUE_APP_I18N_LOCALE,
    system: localStorage.getItem('cdb_system') || '',
    browser: localStorage.getItem('cdb_browser') || '',
    cabinet: null,
    localeArr: [
      { key: 0, label: '简体中文', value: 'zh-CN', currency: '人民币', money: '￥' },
      { key: 1, label: 'English', value: 'en-US', currency: 'dollar', money: '$' },
      { key: 2, label: "Deutsch", value: "de-DE", currency: "dollar", money: "$" },
      { key: 3, label: "español", value: "es-ES", currency: "dollar", money: "$" },
      { key: 4, label: "Français", value: "fr-FR", currency: "dollar", money: "$" }

    ],
    inviteCode: sessionStorage.getItem('cdb_invite_code') || '',
    coupon: null,
    area: localStorage.getItem('cdb_area') || '',
    ismobile: localStorage.getItem('cdb_ismobile') || false,
    loginMode: sessionStorage.getItem('cdb_loginmode') || 'phone',
    paypalTradeNo: JSON.parse(localStorage.getItem("cdb_paypalTradeNo")),
    paymentId: JSON.parse(localStorage.getItem("cdb_paymentId")),
    agentId: 'BJCD000001',
    userType: JSON.parse(localStorage.getItem('cdb_user_type')), // 游客类型(tourist_login)
    paypalType: JSON.parse(localStorage.getItem("cdb_paypalType"))
    // agentId: '234165056156425'
  },
  getters: {
    locale: state => {
      return state.localeArr.find(obj => obj.value === state.lang)
    }
  },
  mutations: {
    paymentId(state, payload) {
      localStorage.setItem("cdb_paymentId", JSON.stringify(payload));
      state.paymentId = payload;
    },
    paypalTradeNo(state, payload) {
      localStorage.setItem("cdb_paypalTradeNo", JSON.stringify(payload));
      state.paypalTradeNo = payload;
    },
    paypalType(state, payload) {
      localStorage.setItem("cdb_paypalType", JSON.stringify(payload));
      state.paypalType = payload;
    },
    safeArea (state, payload) {
      localStorage.setItem('cdb_safe_area', JSON.stringify(payload))
      state.safeArea = payload
    },
    user (state, payload) {
      localStorage.setItem('cdb_user', JSON.stringify(payload))
      state.user = payload
    },
    userPwd (state, payload) {
      localStorage.setItem('cdb_user_pwd', JSON.stringify(payload))
      state.userPwd = payload
    },
    token (state, payload) {
      localStorage.setItem('cdb_token', payload)
      state.token = payload
    },
    appleIdToken (state, payload) {
      state.appleIdToken = payload
    },
    loading (state, payload) {
      state.loading = payload
    },
    isLangView (state, payload) {
      state.isLangView = payload
    },
    qrcode (state, payload) {
      localStorage.setItem('cdb_qrcode', payload)
      state.qrcode = payload
    },
    zhcode (state, payload) {
      sessionStorage.setItem('cdb_zhcode', payload)
      state.zhcode = payload
    },
    lang (state, payload) {
      localStorage.setItem('cdb_lang', payload)
      state.lang = payload
    },
    system (state, payload) {
      localStorage.setItem('cdb_system', payload)
      state.system = payload
    },
    browser (state, payload) {
      localStorage.setItem('cdb_browser', payload)
      state.browser = payload
    },
    cabinet (state, payload) {
      state.cabinet = payload
    },
    inviteCode (state, payload) {
      sessionStorage.setItem('cdb_invite_code', payload)
      state.inviteCode = payload
    },
    coupon (state, payload) {
      state.coupon = payload
    },
    area (state, payload) {
      localStorage.setItem('cdb_area', payload)
      state.area = payload
    },
    ismobile (state, payload) {
      localStorage.setItem('cdb_ismobile', payload)
      state.ismobile = payload
    },
    loginMode (state, payload) {
      sessionStorage.setItem('cdb_loginmode', payload)
      state.loginMode = payload
    },
    userType (state, payload) {
      sessionStorage.setItem('cdb_user_type', JSON.stringify(payload))
      state.userType = payload
    }
  },
  actions: {
    loginTourist({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.token) {
          resolve(state.token)
          return
        }
        post(
          `${TOURIST_LOGIN}?code=${state.qrcode}`,
          {},
          resp => {
            if (resp.token) {
              commit('token', resp.token)
              commit('userType', 'tourist_login')
              resolve(resp.token)
            } else {
              reject(new Error('Visitor login is not supported'))
            }
          },
          error => {
            reject(error)
            console.log(error)
          }
        )
      })
    },
    loadUser({ commit }) {
      return new Promise((resolve, reject) => {
        get(
          USER_INFO,
          {},
          resp => {
            if (resp.user) {
              commit('user', resp.user)
              resolve(resp.user)
            } else {
              reject(new Error('Login Failed'))
            }
          },
          error => {
            reject(error)
          }
        )
      })
    }
  }
})
